define(["exports", "./pubsubhub", "text!../../assets/caniuse.css", "./utils", "hyperhtml"], function (_exports, _pubsubhub, _caniuse, _utils, _hyperhtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _caniuse = _interopRequireDefault(_caniuse);
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["\n    <div class=\"caniuse-browser\">\n      ", "\n      <ul>\n        ", "\n      </ul>\n    </div>"]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["\n      <button class=\"", "\" title=\"", "\">", "</button>"]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["\n    ", "\n    <a href=\"", "\"\n      title=\"Get details at caniuse.com\">More info\n    </a>"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["\n      <a href=\"", "\">caniuse.com</a>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["\n    <dt class=\"caniuse-title\">Browser support:</dt>\n    <dd class=\"caniuse-stats\">", "</dd>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["<a href=\"", "\">caniuse.com</a>"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n    <style class=\"removeOnSave\">", "</style>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/caniuse";
  _exports.name = name;
  const API_URL = "https://respec.org/caniuse/"; // browser name dictionary

  const BROWSERS = new Map([["and_chr", "Chrome (Android)"], ["and_ff", "Firefox (Android)"], ["and_uc", "UC Browser (Android)"], ["android", "Android"], ["bb", "Blackberry"], ["chrome", "Chrome"], ["edge", "Edge"], ["firefox", "Firefox"], ["ie", "IE"], ["ios_saf", "Safari (iOS)"], ["op_mini", "Opera Mini"], ["op_mob", "Opera Mobile"], ["opera", "Opera"], ["safari", "Safari"], ["samsung", "Samsung Internet"]]); // Keys from https://github.com/Fyrd/caniuse/blob/master/CONTRIBUTING.md

  const supportTitles = new Map([["y", "Supported."], ["a", "Almost supported (aka Partial support)."], ["n", "No support, or disabled by default."], ["p", "No support, but has Polyfill."], ["u", "Support unknown."], ["x", "Requires prefix to work."], ["d", "Disabled by default (needs to enabled)."]]);

  if (!document.querySelector("link[rel='preconnect'][href='https://respec.org']")) {
    const link = (0, _utils.createResourceHint)({
      hint: "preconnect",
      href: "https://respec.org"
    });
    document.head.appendChild(link);
  }

  async function run(conf) {
    if (!conf.caniuse) {
      return; // nothing to do.
    }

    const options = getNormalizedConf(conf);
    conf.caniuse = options; // for tests

    if (!options.feature) {
      return; // no feature to show
    }

    const featureURL = new URL(options.feature, "https://caniuse.com/").href;
    document.head.appendChild((0, _hyperhtml.default)(_templateObject(), _caniuse.default));
    const headDlElem = document.querySelector(".head dl");

    const contentPromise = (async () => {
      try {
        const apiUrl = options.apiURL || API_URL;
        const stats = await fetchStats(apiUrl, options);
        return createTableHTML(featureURL, stats);
      } catch (err) {
        console.error(err);
        const msg = "Couldn't find feature \"".concat(options.feature, "\" on caniuse.com? ") + "Please check the feature key on [caniuse.com](https://caniuse.com)";
        (0, _pubsubhub.pub)("error", msg);
        return (0, _hyperhtml.default)(_templateObject2(), featureURL);
      }
    })();

    const definitionPair = (0, _hyperhtml.default)(_templateObject3(), {
      any: contentPromise,
      placeholder: "Fetching data from caniuse.com..."
    });
    headDlElem.append(...definitionPair.childNodes);
    await contentPromise; // remove from export

    (0, _pubsubhub.pub)("amend-user-config", {
      caniuse: options.feature
    });
    (0, _pubsubhub.sub)("beforesave", outputDoc => {
      _hyperhtml.default.bind(outputDoc.querySelector(".caniuse-stats"))(_templateObject4(), featureURL);
    });
  }
  /**
   * returns normalized `conf.caniuse` configuration
   * @param {Object} conf   configuration settings
   */


  function getNormalizedConf(conf) {
    const DEFAULTS = {
      versions: 4
    };

    if (typeof conf.caniuse === "string") {
      return _objectSpread({
        feature: conf.caniuse
      }, DEFAULTS);
    }

    const caniuseConf = _objectSpread({}, DEFAULTS, {}, conf.caniuse);

    const {
      browsers
    } = caniuseConf;

    if (Array.isArray(browsers)) {
      const invalidBrowsers = browsers.filter(browser => !BROWSERS.has(browser));

      if (invalidBrowsers.length) {
        const names = invalidBrowsers.map(b => "\"`".concat(b, "`\"")).join(", ");
        (0, _pubsubhub.pub)("warn", "Ignoring invalid browser(s): ".concat(names, " in ") + "[`respecConfig.caniuse.browsers`](https://github.com/w3c/respec/wiki/caniuse)");
      }
    }

    return caniuseConf;
  }
  /**
   * @param {string} apiURL
   * @typedef {Record<string, [string, string[]][]>} ApiResponse
   * @return {Promise<ApiResponse>}
   * @throws {Error} on failure
   */


  async function fetchStats(apiURL, options) {
    const {
      feature,
      versions,
      browsers
    } = options;
    const searchParams = new URLSearchParams();
    searchParams.set("feature", feature);
    searchParams.set("versions", versions);

    if (Array.isArray(browsers)) {
      searchParams.set("browsers", browsers.join(","));
    }

    const url = "".concat(apiURL, "?").concat(searchParams.toString());
    const response = await fetch(url);
    const stats = await response.json();
    return stats;
  }
  /**
   * Get HTML element for the canIUse support table.
   * @param {string} featureURL
   * @param {ApiResponse} stats
   */


  function createTableHTML(featureURL, stats) {
    // render the support table
    return (0, _hyperhtml.default)(_templateObject5(), Object.entries(stats).map(addBrowser), featureURL);
  }
  /**
   * Add a browser and it's support to table.
   * @param {[ string, ApiResponse["browserName"] ]} args
   */


  function addBrowser([browserName, browserData]) {
    /** @param {string[]} supportKeys */
    const getSupport = supportKeys => {
      const titles = supportKeys.filter(key => supportTitles.has(key)).map(key => supportTitles.get(key));
      return {
        className: "caniuse-cell ".concat(supportKeys.join(" ")),
        title: titles.join(" ")
      };
    };
    /** @param {[string, string[]]} args */


    const addLatestVersion = ([version, supportKeys]) => {
      const {
        className,
        title
      } = getSupport(supportKeys);
      const buttonText = "".concat(BROWSERS.get(browserName) || browserName, " ").concat(version);
      return (0, _hyperhtml.default)(_templateObject6(), className, title, buttonText);
    };
    /** @param {[string, string[]]} args */


    const addBrowserVersion = ([version, supportKeys]) => {
      const {
        className,
        title
      } = getSupport(supportKeys);
      return "<li class=\"".concat(className, "\" title=\"").concat(title, "\">").concat(version, "</li>");
    };

    const [latestVersion, ...olderVersions] = browserData;
    return (0, _hyperhtml.default)(_templateObject7(), addLatestVersion(latestVersion), olderVersions.map(addBrowserVersion));
  }
});
//# sourceMappingURL=caniuse.js.map